var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.BookingInfo,{attrs:{"booking-info":_setup.bookingInfoProp}}),_c('v-row',{staticClass:"mt-5"},[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"6","lg":"6"}},[_c('v-btn',{staticClass:"w-100",attrs:{"color":"primary"},on:{"click":_setup.handleDailyRecord}},[_vm._v(" View Daily Record ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }